<template>
  <div
    class="flex flex-col flex-shrink-0 sm:w-64 px-4 py-4 bg-white rounded shadow-2 md:flex-shrink md:w-1/3 xl:py-6 xl:px-10"
  >
    <h3 class="pb-4 text-lg font-bold xl:pb-6 xl:text-2xl font-lufthansa-head">
      {{ title }}
    </h3>
    <div class="flex items-center justify-center h-20 mb-6 xl:h-24 xl:mb-10">
      <slot name="image" />
    </div>

    <slot />

    <div class="flex flex-col justify-end flex-grow pt-6 xl:pt-12 xl:px-4">
      <slot name="buttons" />
    </div>
  </div>
</template>

<script lang="ts">
import TypeCard from '~brand-components/base/type-card/type-card'

export default TypeCard.extend()
</script>
